import { createSlice } from "@reduxjs/toolkit";

export const newAdminData = createSlice({
  name: "new_admin_data",
  initialState: {
    status: false,
    value: { firstname: "", lastname: "", dob: "", gender: "female" },
  },
  reducers: {
    updateNewAdminPersonalData: (state, action) => {
      state.status = true;
      state.value = action.payload;
    },
  },
});

export const { updateNewAdminPersonalData } = newAdminData.actions;

export default newAdminData.reducer;
